module.exports = __webpack_public_path__ + "static/media/undraw_Gift_box_re_vau4.e421b144.svg";